import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FaMapMarkerAlt, FaPhone, FaEnvelope,
  FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp,
  FaCheckCircle, FaTimes
} from 'react-icons/fa';
import { useApp } from '../App';
import './Contact.css';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setShowRequest } = useApp();

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [showModal]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setShowModal(false);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/contact', form);
      setShowModal(true);
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      alert('Failed to send message. Please try again.');
    }
    setLoading(false);
  };

  const closeModal = () => setShowModal(false);

  return (
    <div className="contact-root">
      <div className="contact-hero fade-in">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
      </div>

      <div className="contact-grid">
        <div className="contact-info fade-up">
          <h2>Get In Touch</h2>
          <div className="contact-info-item">
            <FaMapMarkerAlt className="contact-info-icon" />
            <div><h4>Address</h4><p>Kigali, Rwanda</p></div>
          </div>
          <div className="contact-info-item">
            <FaPhone className="contact-info-icon" />
            <div><h4>Phone</h4><p>+250 789 951 922</p></div>
          </div>
          <div className="contact-info-item">
            <FaEnvelope className="contact-info-icon" />
            <div><h4>Email</h4><p>karurangabelyse911@gmail.com</p></div>
          </div>
          <h3 className="contact-social-title">Follow Us</h3>
          <div className="contact-socials">
            {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp].map((Ic, i) => (
              <a key={i} href="#" className="contact-social-btn"><Ic /></a>
            ))}
          </div>
          <button
            className="lca-btn-primary contact-request-btn"
            onClick={() => setShowRequest(true)}
          >
            Make a Chef Request
          </button>
        </div>

        <form
          className="contact-form fade-up"
          style={{ animationDelay: '0.15s' }}
          onSubmit={submit}
        >
          <h2>Send Message</h2>
          <input required placeholder="Your Name" value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })} />
          <input required type="email" placeholder="Your Email" value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} />
          <input required placeholder="Subject" value={form.subject}
            onChange={e => setForm({ ...form, subject: e.target.value })} />
          <textarea required rows="5" placeholder="Message" value={form.message}
            onChange={e => setForm({ ...form, message: e.target.value })} />

          <button type="submit" className="lca-btn-primary" disabled={loading}>
            {loading ? 'Sending…' : 'Send Message'}
          </button>
        </form>
      </div>

      {showModal && (
        <div
          className="contact-modal-overlay"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-labelledby="contact-modal-title"
        >
          <div
            className="contact-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="contact-modal-close"
              onClick={closeModal}
              aria-label="Close"
            >
              <FaTimes />
            </button>

            <div className="contact-modal-icon-wrap">
              <div className="contact-modal-icon-ring" />
              <FaCheckCircle className="contact-modal-icon" />
            </div>

            <h2 id="contact-modal-title" className="contact-modal-title">
              Message Sent!
            </h2>

            <p className="contact-modal-text">
              Thank you for reaching out. We'll get back to you shortly —
              a confirmation has been emailed to you.
            </p>

            <div className="contact-modal-divider" />

            <div className="contact-modal-meta">
              <FaEnvelope className="contact-modal-meta-icon" />
              <span>Check your inbox for a confirmation email</span>
            </div>

            <button
              className="lca-btn-primary contact-modal-btn"
              onClick={closeModal}
            >
              Got it, thanks!
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contact;
